import {
  getGetTopLessonHooksQueryKey,
  getGetUserLessonHooksQueryKey,
  likeLessonHook,
  unlikeLessonHook,
  useDeleteLessonHook,
  useGetTopLessonHooks,
  useGetUserLessonHooks,
} from "@packages/api/madlenAPI";
import { LessonHookResponseDto } from "@packages/api/madlenAPI.schemas";
import { HookCard } from "../../components/hooks/HookCard";
import GenericToolPage from "../../components/tool_components/GenericToolPage";

interface ExtendedTool {
  id: number;
  imageUrl?: string;
  prompt?: string;
  authorName?: string;
  likeCount?: number;
  courseName?: string;
  gradeLevel?: number;
  didUserLiked?: boolean;
  description?: string;
  hooks?: Record<string, any>;
  createdAt?: string;
  isEditable?: boolean;
}

const HookDetailComponent = ({ tool }: { tool: ExtendedTool }) => {
  return (
    <HookCard
      lessonHook={tool as LessonHookResponseDto}
      isImageLoading={false}
      isEditable={tool.isEditable ?? true}
    />
  );
};

const HooksView = () => {
  return (
    <GenericToolPage
      useGetTools={useGetUserLessonHooks}
      useDeleteTool={useDeleteLessonHook}
      getGetToolsQueryKey={getGetUserLessonHooksQueryKey}
      useGetTopTools={useGetTopLessonHooks}
      likeTool={likeLessonHook}
      unlikeTool={unlikeLessonHook}
      getGetTopToolsQueryKey={getGetTopLessonHooksQueryKey}
      toolType="hooks"
      toolPath="hooks"
      DetailComponent={HookDetailComponent}
      colors={{
        light: "from-indigo-400 to-indigo-600",
        dark: "dark:from-indigo-400 dark:to-indigo-600",
        iconBg: "bg-indigo-100 dark:bg-indigo-900/50",
        iconColor: "text-indigo-600 dark:text-indigo-400",
        hover: "hover:bg-blue-50 dark:hover:bg-blue-900/20",
      }}
      toolColor="indigo"
      gradientColor="yellow"
    />
  );
};

export default HooksView;
